import { useHistory } from 'react-router-dom';
// Material
import { Button, Divider } from '@mui/material';
// Estilos
import { mainContainer, subtitleStyle, titleHighlightedStyle, titleStyle } from 'Components/Title/style';
import { acceptButton, ButtonContainer, cancelButton, disabledButton } from '../style.js';

function Title({
  title = '',
  subtitle = '',
  titleHighlighted = '',
  cancel = '',
  save = '',
  centerText = false,
  isDisabled = false,
  eventButton = () => {},
}) {
  const history = useHistory();
  const handleClick = () => {
    eventButton();
  };
  const width = centerText ? '100%' : '75%';
  const textAlign = centerText ? 'center' : 'left';
  const styleText = { width, textAlign };

  return (
    <div style={mainContainer}>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={styleText}>
          <h1 style={titleStyle}>{title}</h1>
          <span style={titleHighlightedStyle}> {titleHighlighted}</span>
          <p style={subtitleStyle}>{subtitle}</p>
        </div>
        <ButtonContainer>
          <Button variant="outlined" color="success" style={cancelButton} onClick={() => history.goBack()}>
            {cancel}
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="success"
            style={isDisabled ? disabledButton : acceptButton}
            disabled={isDisabled}
            onClick={handleClick}
          >
            {save}
          </Button>
        </ButtonContainer>
      </div>
      <Divider variant="large" style={{ marginBottom: '2rem' }} />
    </div>
  );
}

export default Title;
